// @flow

import React, { PureComponent } from 'react';
import i18n from 'app/common/lib/i18n';
import ProfileBoardCardContainer from 'app/common/react/components/profile/ProfileBoardCard/ProfileBoardCardContainer';
import ProfileEmptyState from 'app/common/react/components/profile/ProfileEmptyState/ProfileEmptyState';
import ProfileEmptyStateText from 'app/common/react/components/profile/ProfileEmptyState/ProfileEmptyStateText';
import ProfileGridLayout from 'app/common/react/components/profile/ProfileGridLayout/ProfileGridLayout';
import type { ProfileBoardType } from 'app/common/react/components/profile/ProfileBoardCard/commonTypes';
import type { ProfileUser } from 'app/packages/pinterest-flow-types/user';
import withResource from 'app/common/lib/react/withResource';
import { compose } from 'redux';
import { track } from 'app/common/lib/react/analytics';
import withViewer, { type Viewer } from 'app/common/lib/react/withViewer';
import { Box, ScrollFetch, Spinner } from 'gestalt';

type Props = {|
  boardsResource: {
    data: Array<ProfileBoardType>,
    fetchMore: () => void,
    isAtEnd: boolean,
    isFetching: boolean,
    isLoaded: boolean,
  },
  user: ProfileUser,
  viewer: Viewer,
|};

export class BoardsFeed extends PureComponent<Props> {
  handleFindBoardsClick = () => {
    track(PCONST.thrift.EventType.CLICK, {
      view: PCONST.thrift.ViewType.USER,
      viewParameter: PCONST.thrift.ViewParameterType.USER_FOLLOWING,
      element: PCONST.thrift.ElementType.SEARCH_BOARDS_BUTTON,
    });
  };

  render() {
    const {
      boardsResource: { data, fetchMore, isAtEnd, isFetching, isLoaded },
      user,
    } = this.props;
    return (
      <Box>
        <ScrollFetch isAtEnd={isAtEnd} isFetching={isFetching} fetchMore={fetchMore} />
        {isLoaded &&
          (data.length ? (
            <ProfileGridLayout itemWidth={317}>
              {data.map((board, index) => (
                <Box width={317} key={board.id} paddingX={1} paddingY={4}>
                  <div className="item relative">
                    <ProfileBoardCardContainer board={board} slotIndex={index} layout="wide" />
                  </div>
                </Box>
              ))}
            </ProfileGridLayout>
          ) : (
            <ProfileEmptyState>
              <ProfileEmptyStateText subject="boards" surface="following" user={user} />
            </ProfileEmptyState>
          ))}
        <Spinner
          accessibilityLabel={i18n._(
            'Loading additional boards',
            'Label for the loading state spinner in the Boards section of the Following page',
          )}
          show={isFetching || !isLoaded}
        />
      </Box>
    );
  }
}

export default compose(
  withViewer,
  withResource({
    name: 'BoardFollowingResource',
    key: 'boardsResource',
    options: ({ user }) => ({
      field_set_key: 'profile_grid_item',
      username: user.username,
    }),
  }),
)(BoardsFeed);
